module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/xic/xic.component.css
// module id = ./src/app/xic/xic.component.css
// module chunks = main